import { sortBy } from "lodash";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { ProfileExport } from "PFTypes";
import React from "react";

import { sortInternalExperiences } from "../../../helpers/sort_internal_experiences";
import { defaultCompanyName } from "../../../local_export_build_ey_pptx/constants";
import { formatExperienceText } from "../../../local_export_build_ey_pptx/helpers";
import { Position } from "../types";
import { Field } from "./field";

type PositionsProps = {
  className?: string;
  title: string;
  positions: { items: Position[] };
  internalExperiences?: ProfileExport["internal_experiences"];
};

export const Positions = ({ className, positions, title, internalExperiences }: PositionsProps) => {
  const { formatDate } = useDateFormatter();

  if (!positions?.items || positions.items.length === 0) {
    return null;
  }

  const orderedPositions = sortBy(positions.items, (pos) => -Number(pos.main));
  const orderedInternalExperiences = sortInternalExperiences(internalExperiences || []);

  return (
    <Field className={className} title={title}>
      {orderedPositions.map(({ id, jobTitle, companyName, summary, startDate, endDate }) => {
        const filteredInternalExperiences = (orderedInternalExperiences || []).filter(
          ({ metadata }) => metadata.position_id === id
        );
        return (
          <div key={id}>
            <strong>{companyName || defaultCompanyName}</strong>
            <div>
              <strong>{formatExperienceText(formatDate, jobTitle, startDate, endDate)}</strong>

              <div>{summary}</div>
              {filteredInternalExperiences.length > 0 && (
                <ul>
                  {filteredInternalExperiences.map(({ name, description, metadata: { date_range } }) => (
                    <li key={name}>
                      <strong>
                        {formatExperienceText(formatDate, name, date_range?.start_date, date_range?.end_date)}
                      </strong>
                      <div>{description}</div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        );
      })}
    </Field>
  );
};
